// 加盟店審査画面の入力内容に対する注意喚起 (IH-1310)
// 保存内容・保存可否には影響しない、表示だけの機能。
const attentionClass = "is-attention"

const toggle = (element, on) => {
  element.classList.toggle(attentionClass, on)
}

// 電話番号: ハイフン等を除いた数字が 1〜10 桁のとき注意喚起する。
// JCB審査で10桁の番号がエラーになるため、11桁（携帯番号）への差し替えを促す。
// 通常加盟店は数字のみ・歯科加盟店はハイフン区切り必須とフォーマットが異なるため、
// 数字以外を落としてから桁数を数える。空欄は対象外。
const isShortTel = (value) => {
  const digits = (value || "").replace(/[^\d]/g, "")
  return digits.length > 0 && digits.length < 11
}

// 電話番号欄の判定を有効化する。
// 入力途中は必ず11桁未満になるため、判定は blur 時のみとする。
const activateTelAttention = (selectors) => {
  selectors.forEach(selector => {
    const element = document.querySelector(selector)
    if (! element) return

    const update = () => toggle(element, isShortTel(element.value))
    element.addEventListener("blur", update)
    update()
  })
}

// サイトURL: ダミーURLのままなら注意喚起する。
// ダミーURLの値は Settings.dummy_value.dental_url をビューから data 属性で受け取る。
const activateDummyUrlAttention = (selector) => {
  const element = document.querySelector(selector)
  if (! element) return

  const dummyUrl = element.dataset.dummyUrl
  if (! dummyUrl) return

  const update = () => toggle(element, element.value === dummyUrl)
  element.addEventListener("input", update)
  update()
}

export default {
  activateTelAttention,
  activateDummyUrlAttention,
}
